module.exports = __webpack_public_path__ + "img/logo-mini.4b640a87.png";